import { canonicalizeProvinceName } from '../data/parcelFilterContract';

/** Por debajo, el encuadre es país: no se manda `view_province`. */
const VIEW_PROVINCE_MIN_ZOOM = 7;

const ADMIN_PROVINCE_LAYERS = ['provinces-admin-hit-area', 'provinces-admin-borders'];
const ADMIN_NAME_KEYS = [
  'province_name', 'name', 'NOMPROV', 'provincia', 'PROVINCIA', 'NAME_1', 'Name',
];

function provinceNameFromProps(props) {
  if (!props || typeof props !== 'object') return null;
  for (const key of ADMIN_NAME_KEYS) {
    const canonical = canonicalizeProvinceName(props[key]);
    if (canonical) return canonical;
  }
  return canonicalizeProvinceName(props.province_name);
}

/**
 * Provincia visible para `POST /parsesearchquery` (`view_province`).
 * Desambigua homónimos de barrio (“Villa Belgrano” en Córdoba ≠ Bahía Blanca).
 * Si no hay una sola provincia clara, se omite: el parse usa solo la frase.
 *
 * @param {object} [options]
 * @param {string|null} [options.selectedProvinceName] breadcrumb / click admin
 * @param {import('maplibre-gl').Map|null} [options.map]
 * @returns {string|null} valor canónico (`Córdoba`, `CABA`, …) o `null`
 */
export function resolveViewProvince({ selectedProvinceName, map } = {}) {
  const fromSelection = canonicalizeProvinceName(selectedProvinceName);
  if (fromSelection) return fromSelection;
  if (!map || typeof map.getZoom !== 'function' || map.getZoom() < VIEW_PROVINCE_MIN_ZOOM) {
    return null;
  }
  if (typeof map.project !== 'function' || typeof map.queryRenderedFeatures !== 'function') {
    return null;
  }

  let point;
  try {
    point = map.project(map.getCenter());
  } catch {
    return null;
  }

  const adminLayers = ADMIN_PROVINCE_LAYERS.filter((id) => map.getLayer?.(id));
  if (adminLayers.length) {
    const adminHits = map.queryRenderedFeatures(point, { layers: adminLayers });
    for (const hit of adminHits) {
      const name = provinceNameFromProps(hit?.properties);
      if (name) return name;
    }
  }

  const hits = map.queryRenderedFeatures(point);
  for (const hit of hits) {
    const name = canonicalizeProvinceName(hit?.properties?.province_name)
      || provinceNameFromProps(hit?.properties);
    if (name) return name;
  }
  return null;
}
